var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedecinedouce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6281 70H8.2945C3.73252 70 0 66.3027 0 61.6914V8.30861C0 3.73887 3.69105 0 8.2945 0H61.6281C66.1901 0 69.9226 3.69733 69.9226 8.30861V61.7329C69.9226 66.3027 66.1901 70 61.6281 70Z",
    fill: "#6691CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4573 16.4536C52.9371 15.9337 52.3081 15.5359 51.6159 15.2888C50.9237 15.0417 50.1853 14.9515 49.4541 15.0247C44.805 15.4749 29.1698 17.414 23.1308 23.4566C20.2441 26.3561 18.5323 30.2242 18.3261 34.314C18.1198 38.4037 19.4337 42.4249 22.0139 45.6011L40.4239 27.1599C40.7378 26.8561 41.1583 26.6881 41.5947 26.6919C42.0312 26.6957 42.4486 26.871 42.7573 27.1802C43.0659 27.4893 43.2409 27.9075 43.2447 28.3447C43.2485 28.7819 43.0808 29.2031 42.7775 29.5175L24.3743 47.9588C27.544 50.545 31.558 51.8627 35.641 51.6573C39.724 51.4519 43.5861 49.738 46.4812 46.8466C52.6001 40.7157 54.471 25.1023 54.9021 20.4637C54.9726 19.7298 54.8796 18.9894 54.6297 18.296C54.3799 17.6025 53.9794 16.9732 53.4573 16.4536ZM23.1308 46.8466C23.5281 47.2435 23.9404 47.6164 24.3676 47.9655L17.8093 54.5349C17.4945 54.8379 17.0735 55.0049 16.637 54.9999C16.2005 54.9949 15.7835 54.8184 15.4757 54.5083C15.1679 54.1982 14.994 53.7795 14.9915 53.3422C14.989 52.9049 15.158 52.4842 15.4623 52.1706L22.0206 45.6011C22.369 46.028 22.7391 46.4431 23.1308 46.8466Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedecinedouce);
export default __webpack_public_path__ + "static/media/medecine douce.27ad65bebeedf61dacdd1d42bd9d8063.svg";
export { ForwardRef as ReactComponent };